import React from 'react';
import './Testimonials.css';

import { Heading } from '../../../components';
import { testiContent } from '../../../constants';

import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';

// Import Swiper core and required modules
import { Pagination, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css'; 
import 'swiper/css/pagination';



const Testimonials = () => {

  return (
    <section className='testimonials'>

      {/* Section heading */}
      <Heading title={'our testimonials'} subTitle={`what our client's say`} linear />

      <div className='testimonial-slider'>

        <Swiper

          // Install Swiper modules
          modules={[Pagination, Autoplay]} // Enable Pagination & Autoplay
          spaceBetween={10} // Space between slides
          loop={true} // Infinite Looping
          autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-slide every 4 seconds
          pagination={{ clickable: true }} // Enable pagination dots
        >
          {/* Map over the testiContent array to render each testimonial */}
          {testiContent.map((testimonial) => {

            // Destructure testimonial object
            const { id, image, content, name, title } = testimonial;

            return (
              <SwiperSlide className='testi-item' key={id}>

                <div className='image'>
                  <img src={image} alt={name} /> {/* Author image */}
                  <div className='quote-left'><FaQuoteLeft /></div> {/* Testimonial quote left icon */}
                </div>
                <p>"{content}"</p> {/* Testimonial */}
                <div className='text'>
                  <h4>{name}</h4> {/* Author name */}
                  <h6>{title}</h6> {/* Author title */}
                </div>
                <div className='quote-right'><FaQuoteRight /></div> {/* Testimonial quote right icon */}

              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default Testimonials;